"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_top_tabs_1 = require("@react-navigation/material-top-tabs");
const native_1 = require("@react-navigation/native");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const DisconnectScreen_1 = require("../../DisconnectScreen");
const components_2 = require("./components");
const styles_1 = __importDefault(require("./styles"));
const Tab = (0, material_top_tabs_1.createMaterialTopTabNavigator)();
const AccountLimitScreen = (props) => {
    const navigation = (0, native_1.useNavigation)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const { defaultTabIndex = 0 } = props.route.params;
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                alignSelf: 'center',
            }, title: "\u30DE\u30A4\u30DA\u30FC\u30B8", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, null), onLeftPress: navigation.goBack }),
        react_1.default.createElement(Tab.Navigator, { initialRouteName: defaultTabIndex == 0 ? Routes_1.default.MUTE_USER_SETTING : Routes_1.default.BLOCK_USER_SETTING, tabBar: (props) => react_1.default.createElement(components_1.CustomTabBar, { ...props }), screenOptions: {
                swipeEnabled: false,
                lazy: true,
            } },
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.BLOCK_USER_SETTING, component: components_2.AccountBlock, options: {
                    tabBarLabel: `ブロック中`,
                } }),
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.MUTE_USER_SETTING, component: components_2.AccountMute, options: {
                    tabBarLabel: `ミュート中`,
                } }))));
};
exports.default = AccountLimitScreen;
